import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getAppConfig } from './get-app-config';

// Import translation files directly for bundling
import nlTranslations from '@/locales/nl/fw-js-shop.json';
import plTranslations from '@/locales/pl/fw-js-shop.json';

const config = getAppConfig();

const resources = {
	nl: {
		'fw-js-shop': nlTranslations,
	},
	pl: {
		'fw-js-shop': plTranslations,
	},
};

void i18n.use(initReactI18next).init({
	lng: config?.locale ?? 'en',
	fallbackLng: 'en',
	debug: false,

	// Single namespace for the entire project
	ns: ['fw-js-shop'],
	defaultNS: 'fw-js-shop',

	// Bundled resources
	resources,

	// Return key instead of empty string when translation is missing or empty
	returnEmptyString: false,

	interpolation: {
		escapeValue: false, // React already escapes
	},

	react: {
		useSuspense: false, // No async loading needed with bundled resources
	},
});

export default i18n;
